<template>
    <div class="code" v-show="allCode" :class="{position:postionStyle}">
        <!-- <div class="header clearfix">
          <img src="~@/assets/image/wx_icon.png" alt="" width="32" height="32" class="head_wx_img">
           <div class="wx_txt">
             <div class="wx_title">关注微信公众号</div>
             <div class="wx_subtitle">获取心理学知识</div>
           </div>
        </div> -->
        <img src="~@/assets/image/wexincode.jpg" alt="" width="160" height="160" class="wx_img">
        <!-- <div>微信扫一扫</div> -->
      <!-- <div class="code_bottom"><span>或搜索关注：</span><span class="company">福能心理</span></div> -->
      <div class="arrow-left" v-show ="showFlg"></div>
      <div class="arrow-bottom"  v-show ="!showFlg"></div>
    </div>
</template>

<script>
    export default {
        name: "Wxhover",
      props:{
        direction:String,
        postionStyle:Boolean,
        allCode:Boolean
      },
      mounted(){
        this.showFlg =  this.right == this.direction ? true: false
      },
      data(){
           return{
             right:"right",
             bottom:"bottom",
             showFlg:false
           }
      }
    }
</script>

<style scoped lang="less">
 .code{
    position: fixed;
    bottom:10%;
    right:100px;
    background-color: #fff;
     padding: 12px;
     font-size:12px;
     font-weight:400;
     color:rgba(153,153,153,1);
     line-height:16px;
     box-shadow:0px 3px 16px 1px rgba(0,0,0,0.1);
     z-index: 99999999999999999;
     border-radius: 4px;

 }
 .code.position{
    position: absolute;
    bottom:60px;
    left: 2px;
    width: 138px;
   text-align: center;

 }
  .header{
     img{
        float: left;
     }
    .wx_txt{
      float: left;
      margin-left: 8px;
      text-align: left;
      .wx_title{
        font-size:14px;
        font-weight:600;
        color:rgba(51,51,51,1);
        line-height:18px;
      }
      .wx_subtitle{
        font-size:12px;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:16px;
      }
    }
  }
  .head_wx_img{
     margin-top: 2px;
  }
  .company{
     color:#39B2EC;
  }
  .code_bottom{
     margin-top: 5px;
  }
  .arrow-left{
    width:0;
    height:0;
    border-top:10px solid transparent;
    border-bottom:10px solid transparent;
    border-left:10px solid #fff;
     position: absolute;
     top:50%;
     margin-top:-5px;
     right:-10px;
  }
  .arrow-bottom{
    width:0;
    height:0;
    border-right:10px solid transparent;
    border-left:10px solid transparent;
    border-top:10px solid #fff;
    position: absolute;
    left:50%;
    margin-left: -5px;
    bottom: -10px;
  }
  .wx_img{
     margin:4px 0px;
  }
</style>
